import * as React from "react";
import DisclaimerText from "./DisclaimerText";
import DisclaimerTitle from "./DisclaimerTitle";
import DisclaimerDescription from "./DisclaimerDescription";

const Disclaimer = () => {
    return <React.Fragment>
        <hr/>
        <DisclaimerTitle>Disclaimer</DisclaimerTitle>
        <DisclaimerDescription>{DisclaimerText}</DisclaimerDescription>
        <hr/>
    </React.Fragment>;
};

export default Disclaimer;


// WEBPACK FOOTER //
// ./src/components/model/Disclaimer/index.tsx